import { useEffect, useRef, useState } from 'react';
import 'intersection-observer';

const DEFAULT_OPTION = {
  root: null, // null defaults to the viewport
  rootMargin: '0px 0px 0px 0px', // offsets for one or more sides of the root's bounding box
  threshold: [0.0], // can use single number or a range between 0.0-1.0
};

type Props = {
  bypassBoundingClientRect?: boolean;
};

const useObserveVisible = ({ bypassBoundingClientRect = false }: Props = {}) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef<HTMLElement>(null);
  const observer = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    observer.current = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting && (bypassBoundingClientRect || entry.boundingClientRect.top < 0)) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    }, DEFAULT_OPTION);

    if (elementRef.current) {
      observer.current.observe(elementRef.current);
    }

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);

  return [isVisible, elementRef];
};

export default useObserveVisible;
